import { MesiEnum } from "../enum/mesi-enum";

export class MetadatiRepertorioDTO {
  id: string;

  segnatura: string;

  numero: string;

  anno: string;

  mese: MesiEnum;

  data: string;
}
